export const uploadConfig = [
  {
    source: "SAP",
    name: "SAP serial numbers",
    uploadPath: "sap_serial_numbers",
    acceptedTypes: ["text/csv", "application/json"],
    extensionLabel: ".csv, .json",
    delimiter: ";",
    fields: [
      {
        name: "Extractdate",
        description: "Extractdate with MM/DD/YYYY format",
        mandatory: true,
      },
      {
        name: "Doid",
        description: "Applicant Id. Must exist in datalake",
        mandatory: true,
      },
      {
        name: "Salesorderid",
        description: "SAP Order Id. Must be in datalake",
        mandatory: true,
      },
      {
        name: "Deliverydate",
        description: "Deliverydate with MM/DD/YYYY format",
        mandatory: true,
      },
      { name: "Productline", description: "SAP Order line", mandatory: true },
      { name: "Prodname", description: "Part number", mandatory: true },
      {
        name: "Proddescr",
        description: "product description",
        mandatory: true,
      },
      {
        name: "BaseSerialNum",
        description: "SAP serial number",
        mandatory: true,
      },
      { name: "OrderableItem", description: "Orderable Item", mandatory: true },
      { name: "TechnicalItem", description: "Technical Item", mandatory: true },
      { name: "Status", description: "ALE Status", mandatory: true },
      { name: "RCODE", description: "RCODE", mandatory: true },
      {
        name: "Warrantystartdate",
        description: "Warrantystartdate with MM/DD/YYYY format",
        mandatory: false,
      },
      {
        name: "Warrantyenddate",
        description: "Warrantyenddate with MM/DD/YYYY format",
        mandatory: false,
      },
      {
        name: "Servicelevel",
        description: "Servicelevel for warranty",
        mandatory: false,
      },
      {
        name: "CustomerSalesorderid",
        description: "Customer order id",
        mandatory: false,
      },
      {
        name: "Updatedate",
        description: "Updatedate with MM/DD/YYYY format",
        mandatory: false,
      },
      { name: "Doname", description: "Applicant name", mandatory: false },
      {
        name: "Salesorderdate",
        description: "Orders date with MM/DD/YYYY format",
        mandatory: false,
      },
      { name: "Sapdeliveryid", description: "Sapdeliveryid", mandatory: false },
      {
        name: "CustomerGroup1",
        description: "CustomerGroup1",
        mandatory: false,
      },
      { name: "CG1descr", description: "CG1 description", mandatory: false },
      {
        name: "CustomerGroup2",
        description: "CustomerGroup2",
        mandatory: false,
      },
      { name: "CG2descr", description: "CG2 description", mandatory: false },
      {
        name: "CustomerGroup3",
        description: "CustomerGroup3",
        mandatory: false,
      },
      { name: "CG3descr", description: "CG3 description", mandatory: false },
      { name: "OIdescr", description: "OI description", mandatory: false },
      { name: "TIdescr", description: "TI description", mandatory: false },
      { name: "OIHWS", description: "OIHWS", mandatory: false },
      {
        name: "OIHWSdescr",
        description: "OIHWS description",
        mandatory: false,
      },
      { name: "SN_Father", description: "SN Father", mandatory: false },
    ],
  },
  {
    source: "BI4",
    name: "SAP Orders",
    uploadPath: "sap_orders",
    acceptedTypes: ["text/csv", "application/json"],
    extensionLabel: ".csv, .json",
    delimiter: ";",
    fields: [
      { name: "Order Id", description: "SAP Order Id", mandatory: true },
      {
        name: "Sold to Id",
        description: "Applicant Id. Must exist in datalake",
        mandatory: true,
      },
      {
        name: "Order date",
        description: "Order date in YYYY/MM/DD HH:MM:SS format",
        mandatory: true,
      },
      { name: "Order post", description: "Order Line", mandatory: true },
      {
        name: "Qty Items Orders",
        description: "Order quantity",
        mandatory: true,
      },
      { name: "Part number", description: "Part number", mandatory: true },
      { name: "Post sup", description: "Parent line", mandatory: true },
      {
        name: "Customer PO",
        description: "Customer Purchase Order",
        mandatory: false,
      },
      { name: "End User Name", description: "End User Name", mandatory: false },
      { name: "End User Postal Code", description: "", mandatory: false },
      { name: "End User Address", description: "", mandatory: false },
      { name: "End User City", description: "", mandatory: false },
      { name: "End User country ID", description: "", mandatory: false },
      { name: "End User country", description: "", mandatory: false },
      { name: "End user activity sector", description: "", mandatory: false },
      {
        name: "End User sub-activity sector",
        description: "",
        mandatory: false,
      },
      {
        name: "Part description",
        description: "Part description",
        mandatory: false,
      },
      {
        name: "Document Currency Code",
        description: "Document Currency Code",
        mandatory: false,
      },
      { name: "Post type", description: "Post type", mandatory: false },
      { name: "Post type Id", description: "Post type Id", mandatory: false },
      { name: "ED/SP Key", description: "ED/SP Key", mandatory: false },
      {
        name: "Rejection Reason",
        description: "Rejection Reason",
        mandatory: false,
      },
      {
        name: "Cancelation Flag",
        description: "Cancelation Flag",
        mandatory: false,
      },
      {
        name: "Object Status (item)",
        description: "Object Status (item)",
        mandatory: false,
      },
      {
        name: "First Ack EXW date",
        description: "First Ack EXW date",
        mandatory: false,
      },
      {
        name: "Last Ack EXW date",
        description: "Last Ack EXW date",
        mandatory: false,
      },
      {
        name: "Serial no. profile",
        description: "Serial no. profile",
        mandatory: false,
      },
      {
        name: "Last Ack delivery date",
        description: "Last Ack delivery date",
        mandatory: false,
      },
      {
        name: "Sales organization Id",
        description: "Sales organization Id",
        mandatory: false,
      },
      { name: "Order type Id", description: "Order type Id", mandatory: false },
      { name: "Order type", description: "Order type", mandatory: false },
    ],
  },
  {
    source: "LDS",
    name: "ARUBA Serial Number",
    uploadPath: "aruba/diff",
    acceptedTypes: ["text/csv", "application/json"],
    extensionLabel: ".csv, .json",
    delimiter: ",",
    fields: [
      {
        name: "arb_cert_serial_no",
        description: "serial number",
        mandatory: true,
      },
      { name: "customer_number", description: "applicant id", mandatory: true },
      { name: "order_number", description: "order_number", mandatory: true },
      { name: "alu_part_no", description: "part number", mandatory: true },
      {
        name: "created_date",
        description: "created_date with format MM/DD/YYYY",
        mandatory: true,
      },
      { name: "quantity", description: "quantity", mandatory: true },
      {
        name: "sap_order_number",
        description: "sap_order_number",
        mandatory: true,
      },
      {
        name: "transaction_code",
        description: "transaction_code",
        mandatory: false,
      },
      {
        name: "transaction_type",
        description: "transaction_type",
        mandatory: false,
      },
      { name: "bp_po_number", description: "bp_po_number", mandatory: false },
    ],
  },
  {
    source: "LDS",
    name: "OV2500NMS",
    uploadPath: "ov2500nms/diff",
    acceptedTypes: ["text/csv", "application/json"],
    extensionLabel: ".csv, .json",
    delimiter: ",",
    fields: [
      { name: "record type", description: "record type", mandatory: true },
      { name: "parent", description: "parent", mandatory: true },
      { name: "part number", description: "part number", mandatory: true },
      { name: "quantity", description: "quantity", mandatory: true },
      {
        name: "created",
        description: "created with format YYYY-MM-DD",
        mandatory: true,
      },
      {
        name: "customer number",
        description: "customer number",
        mandatory: true,
      },
      { name: "order number", description: "order number", mandatory: true },
      {
        name: "quantity total",
        description: "quantity total",
        mandatory: true,
      },
      { name: "company name", description: "company name", mandatory: false },
      { name: "phone", description: "phone", mandatory: false },
      {
        name: "customer email",
        description: "customer email",
        mandatory: false,
      },
      { name: "user name", description: "user name", mandatory: false },
      { name: "product type", description: "product type", mandatory: false },
    ],
  },
  {
    source: "SAP",
    name: "YCT1 Contracts",
    uploadPath: "contracts/diff/yct1",
    acceptedTypes: ["text/csv", "application/json"],
    extensionLabel: ".csv, .json",
    delimiter: ",",
    fields: [
      { name: "offer_number", description: "offer_number", mandatory: true },
      {
        name: "contract_number",
        description: "contract_number",
        mandatory: true,
      },
      { name: "system_id", description: "system_id", mandatory: true },
      { name: "cpu_1", description: "cpu_1", mandatory: true },
      { name: "cpu_2", description: "cpu_2", mandatory: false },
      { name: "order_number", description: "order_number", mandatory: true },
      { name: "material", description: "material", mandatory: true },
      {
        name: "contract_item_start_date",
        description: "contract_item_start_date with format YYYY-MM-DD",
        mandatory: true,
      },
      {
        name: "contract_item_inst_date",
        description: "contract_item_inst_date with format YYYY-MM-DD",
        mandatory: true,
      },
      {
        name: "contract_item_end_date",
        description: "contract_item_end_date with format YYYY-MM-DD",
        mandatory: true,
      },
      {
        name: "item_created_date",
        description: "item_created_date with format YYYY-MM-DD",
        mandatory: true,
      },
      { name: "service_level", description: "service_level", mandatory: true },
      { name: "software_type", description: "software_type", mandatory: true },
      {
        name: "material_description",
        description: "material_description",
        mandatory: false,
      },
      {
        name: "customer_order",
        description: "customer_order",
        mandatory: false,
      },
      {
        name: "contract_created_date",
        description: "contract_created_date",
        mandatory: false,
      },
      {
        name: "contract_created_by",
        description: "contract_created_by",
        mandatory: false,
      },
      {
        name: "contract_item_number",
        description: "contract_item_number",
        mandatory: false,
      },
      { name: "item_category", description: "item_category", mandatory: false },
      {
        name: "recipient_name",
        description: "recipient_name",
        mandatory: false,
      },
      {
        name: "software_value_item",
        description: "software_value_item",
        mandatory: false,
      },
      {
        name: "software_value_correction",
        description: "software_value_correction",
        mandatory: false,
      },
      {
        name: "software_value_contract",
        description: "software_value_contract",
        mandatory: false,
      },
      {
        name: "total_cpuid_per_soft_type",
        description: "total_cpuid_per_soft_type",
        mandatory: false,
      },
      {
        name: "total_cpuid_all_soft_types",
        description: "total_cpuid_all_soft_types",
        mandatory: false,
      },
      {
        name: "wpl_ind_total_contract",
        description: "wpl_ind_total_contract",
        mandatory: false,
      },
      { name: "net_price", description: "net_price", mandatory: false },
      {
        name: "discount_amount",
        description: "discount_amount",
        mandatory: false,
      },
      {
        name: "enrich_price_x_2",
        description: "enrich_price_x_2",
        mandatory: false,
      },
      { name: "total_np", description: "total_np", mandatory: false },
      {
        name: "total_np_per_sub_contracts",
        description: "total_np_per_sub_contracts",
        mandatory: false,
      },
      {
        name: "total_np_all_sub_contracts",
        description: "total_np_all_sub_contracts",
        mandatory: false,
      },
      { name: "currency", description: "currency", mandatory: false },
      { name: "upfront", description: "upfront", mandatory: false },
      { name: "free", description: "free", mandatory: false },
      {
        name: "text_observation",
        description: "text_observation",
        mandatory: false,
      },
      {
        name: "software_release",
        description: "software_release",
        mandatory: false,
      },
      {
        name: "penalty_ypfr_percentage",
        description: "penalty_ypfr_percentage",
        mandatory: false,
      },
      {
        name: "service_discount_yrca_percentage",
        description: "service_discount_yrca_percentage",
        mandatory: false,
      },
      {
        name: "frame_agreement_gc4",
        description: "frame_agreement_gc4",
        mandatory: false,
      },
      { name: "project_name", description: "project_name", mandatory: false },
      { name: "customer_name", description: "customer_name", mandatory: false },
      {
        name: "discount_key_number_edr_sdr",
        description: "discount_key_number_edr_sdr",
        mandatory: false,
      },
      { name: "nb_years", description: "nb_years", mandatory: false },
      {
        name: "stand_alone_syst",
        description: "stand_alone_syst",
        mandatory: false,
      },
      { name: "cso_upgrade", description: "cso_upgrade", mandatory: false },
      { name: "b2b_flag", description: "b2b_flag", mandatory: false },
      { name: "ip_centr", description: "ip_centr", mandatory: false },
      {
        name: "first_inv_billing_date",
        description: "first_inv_billing_date",
        mandatory: false,
      },
      {
        name: "cancel_reason_co_head",
        description: "cancel_reason_co_head",
        mandatory: false,
      },
      {
        name: "cancel_reason_co_item",
        description: "cancel_reason_co_item",
        mandatory: false,
      },
      { name: "co_adj_text", description: "co_adj_text", mandatory: false },
      {
        name: "co_sps_migr_text",
        description: "co_sps_migr_text",
        mandatory: false,
      },
    ],
  },
  {
    source: "SAP",
    name: "YCT2 Contracts",
    uploadPath: "contracts/diff/yct2",
    acceptedTypes: ["text/csv", "application/json"],
    extensionLabel: ".csv, .json",
    delimiter: ",",
    fields: [
      { name: "offer_number", description: "offer_number", mandatory: true },
      {
        name: "contract_number",
        description: "contract_number",
        mandatory: true,
      },
      { name: "system_id", description: "system_id", mandatory: true },
      { name: "cpu_1", description: "cpu_1", mandatory: true },
      { name: "cpu_2", description: "cpu_2", mandatory: false },
      { name: "order_number", description: "order_number", mandatory: true },
      { name: "material", description: "material", mandatory: true },
      {
        name: "contract_item_start_date",
        description: "contract_item_start_date with format YYYY-MM-DD",
        mandatory: true,
      },
      {
        name: "contract_item_inst_date",
        description: "contract_item_inst_date with format YYYY-MM-DD",
        mandatory: true,
      },
      {
        name: "contract_item_end_date",
        description: "contract_item_end_date with format YYYY-MM-DD",
        mandatory: true,
      },
      {
        name: "item_created_date",
        description: "item_created_date with format YYYY-MM-DD",
        mandatory: true,
      },
      { name: "service_level", description: "service_level", mandatory: true },
      { name: "software_type", description: "software_type", mandatory: true },
      {
        name: "material_description",
        description: "material_description",
        mandatory: false,
      },
      {
        name: "customer_order",
        description: "customer_order",
        mandatory: false,
      },
      {
        name: "contract_created_date",
        description: "contract_created_date",
        mandatory: false,
      },
      {
        name: "contract_created_by",
        description: "contract_created_by",
        mandatory: false,
      },
      {
        name: "contract_item_number",
        description: "contract_item_number",
        mandatory: false,
      },
      { name: "item_category", description: "item_category", mandatory: false },
      {
        name: "recipient_name",
        description: "recipient_name",
        mandatory: false,
      },
      {
        name: "software_value_item",
        description: "software_value_item",
        mandatory: false,
      },
      {
        name: "software_value_correction",
        description: "software_value_correction",
        mandatory: false,
      },
      {
        name: "software_value_contract",
        description: "software_value_contract",
        mandatory: false,
      },
      {
        name: "total_cpuid_per_soft_type",
        description: "total_cpuid_per_soft_type",
        mandatory: false,
      },
      {
        name: "total_cpuid_all_soft_types",
        description: "total_cpuid_all_soft_types",
        mandatory: false,
      },
      {
        name: "wpl_ind_total_contract",
        description: "wpl_ind_total_contract",
        mandatory: false,
      },
      { name: "net_price", description: "net_price", mandatory: false },
      {
        name: "discount_amount",
        description: "discount_amount",
        mandatory: false,
      },
      {
        name: "enrich_price_x_2",
        description: "enrich_price_x_2",
        mandatory: false,
      },
      { name: "total_np", description: "total_np", mandatory: false },
      {
        name: "total_np_per_sub_contracts",
        description: "total_np_per_sub_contracts",
        mandatory: false,
      },
      {
        name: "total_np_all_sub_contracts",
        description: "total_np_all_sub_contracts",
        mandatory: false,
      },
      { name: "currency", description: "currency", mandatory: false },
      { name: "upfront", description: "upfront", mandatory: false },
      { name: "free", description: "free", mandatory: false },
      {
        name: "text_observation",
        description: "text_observation",
        mandatory: false,
      },
      {
        name: "software_release",
        description: "software_release",
        mandatory: false,
      },
      {
        name: "penalty_ypfr_percentage",
        description: "penalty_ypfr_percentage",
        mandatory: false,
      },
      {
        name: "service_discount_yrca_percentage",
        description: "service_discount_yrca_percentage",
        mandatory: false,
      },
      {
        name: "frame_agreement_gc4",
        description: "frame_agreement_gc4",
        mandatory: false,
      },
      { name: "project_name", description: "project_name", mandatory: false },
      { name: "customer_name", description: "customer_name", mandatory: false },
      {
        name: "discount_key_number_edr_sdr",
        description: "discount_key_number_edr_sdr",
        mandatory: false,
      },
      { name: "nb_years", description: "nb_years", mandatory: false },
      {
        name: "stand_alone_syst",
        description: "stand_alone_syst",
        mandatory: false,
      },
      { name: "cso_upgrade", description: "cso_upgrade", mandatory: false },
      { name: "b2b_flag", description: "b2b_flag", mandatory: false },
      { name: "ip_centr", description: "ip_centr", mandatory: false },
      {
        name: "first_inv_billing_date",
        description: "first_inv_billing_date",
        mandatory: false,
      },
      {
        name: "cancel_reason_co_head",
        description: "cancel_reason_co_head",
        mandatory: false,
      },
      {
        name: "cancel_reason_co_item",
        description: "cancel_reason_co_item",
        mandatory: false,
      },
      { name: "co_adj_text", description: "co_adj_text", mandatory: false },
      {
        name: "co_sps_migr_text",
        description: "co_sps_migr_text",
        mandatory: false,
      },
    ],
  },
  {
    source: "ELP",
    name: "OXE Order",
    uploadPath: "systems/oxe/orders",
    acceptedTypes: ["text/csv", "application/json"],
    extensionLabel: ".csv, .json",
    delimiter: ";",
    fields: [
      { name: "cpu_id_1", description: "cpu_id_1", mandatory: true },
      { name: "cpu_1_status", description: "cpu_1_status", mandatory: false },
      {
        name: "if_1_system_no_more_used",
        description: "if_1_system_no_more_used",
        mandatory: false,
      },
      { name: "cpu_id_2", description: "cpu_id_2", mandatory: true },
      { name: "cpu_2_status", description: "cpu_2_status", mandatory: false },
      {
        name: "internal_id_of_the_system",
        description: "internal_id_of_the_system",
        mandatory: true,
      },
      { name: "is_opex", description: "is_opex", mandatory: false },
      {
        name: "opex_project_id",
        description: "opex_project_id",
        mandatory: false,
      },
      {
        name: "current_oxe_release_label",
        description: "current_oxe_release_label",
        mandatory: false,
      },
      {
        name: "current_applicant_id",
        description: "current_applicant_id",
        mandatory: true,
      },
      {
        name: "current_applicant_name",
        description: "current_applicant_name",
        mandatory: false,
      },
      {
        name: "delegated_ir_company_id",
        description: "delegated_ir_company_id",
        mandatory: true,
      },
      {
        name: "date_of_ir_delegation_creation_or_modification",
        description: "date_of_ir_delegation_creation_or_modification",
        mandatory: false,
      },
      {
        name: "first_sell_sale_order",
        description: "first_sell_sale_order",
        mandatory: false,
      },
      {
        name: "first_sell_customer_order",
        description: "first_sell_customer_order",
        mandatory: false,
      },
      {
        name: "applicant_id_of_the_first_sell_order",
        description: "applicant_id_of_the_first_sell_order",
        mandatory: false,
      },
      {
        name: "applicant_name_of_the_first_sell_order",
        description: "applicant_name_of_the_first_sell_order",
        mandatory: false,
      },
      {
        name: "actis_id_of_the_first_sell_order",
        description: "actis_id_of_the_first_sell_order",
        mandatory: false,
      },
      {
        name: "date_of_the_last_operation_on_oxe_keys",
        description: "date_of_the_last_operation_on_oxe_keys",
        mandatory: false,
      },
      {
        name: "date_of_the_creation_of_the_system",
        description: "date_of_the_creation_of_the_system",
        mandatory: false,
      },
      {
        name: "ale_order_label_of_the_last_operation_on_oxe_keys",
        description: "ale_order_label_of_the_last_operation_on_oxe_keys",
        mandatory: true,
      },
      {
        name: "customer_order_label_of_the_last_operation_on_oxe_keys",
        description: "customer_order_label_of_the_last_operation_on_oxe_keys",
        mandatory: true,
      },
      {
        name: "last_ale_order_label_on_the_system__first_sell_or_add_on",
        description: "last_ale_order_label_on_the_system__first_sell_or_add_on",
        mandatory: false,
      },
      {
        name: "last_customer_order_label_on_the_system__first_sell_or_add_on",
        description:
          "last_customer_order_label_on_the_system__first_sell_or_add_on",
        mandatory: false,
      },
      {
        name: "actis_id_of_the_last_order",
        description: "actis_id_of_the_last_order",
        mandatory: true,
      },
      {
        name: "last_ale_order_with_actis",
        description: "last_ale_order_with_actis",
        mandatory: true,
      },
      {
        name: "last_customer_order_with_actis",
        description: "last_customer_order_with_actis",
        mandatory: false,
      },
      {
        name: "actis_id_of_the_last_order_with_actis",
        description: "actis_id_of_the_last_order_with_actis",
        mandatory: false,
      },
      { name: "subscription", description: "subscription", mandatory: false },
      {
        name: "internal_cc_id_of_the_system",
        description: "internal_cc_id_of_the_system",
        mandatory: false,
      },
      {
        name: "cc_product_id_key_swk",
        description: "cc_product_id_key_swk",
        mandatory: false,
      },
      {
        name: "id_cc_product_key_swk",
        description: "id_cc_product_key_swk",
        mandatory: false,
      },
      {
        name: "account_key_swk__cc_product_id",
        description: "account_key_swk__cc_product_id",
        mandatory: false,
      },
      {
        name: "account_creation_date_key_swk",
        description: "account_creation_date_key_swk",
        mandatory: false,
      },
      {
        name: "cc_product_id_key_ot",
        description: "cc_product_id_key_ot",
        mandatory: false,
      },
      {
        name: "id_cc_product_key_ot",
        description: "id_cc_product_key_ot",
        mandatory: false,
      },
      {
        name: "account_key_ot__cc_product_id",
        description: "account_key_ot__cc_product_id",
        mandatory: false,
      },
      {
        name: "account_creation_date_key_ot",
        description: "account_creation_date_key_ot",
        mandatory: false,
      },
      {
        name: "cc_product_id_key_otmc",
        description: "cc_product_id_key_otmc",
        mandatory: false,
      },
      {
        name: "id_cc_product_key_otmc",
        description: "id_cc_product_key_otmc",
        mandatory: false,
      },
      {
        name: "account_key_otmc__cc_product_id",
        description: "account_key_otmc__cc_product_id",
        mandatory: false,
      },
      {
        name: "otms_instance_id",
        description: "otms_instance_id",
        mandatory: false,
      },
      {
        name: "account_creation_date_key_otmc",
        description: "account_creation_date_key_otmc",
        mandatory: false,
      },
      {
        name: "more_recent_date_in_the_extracted_period",
        description: "more_recent_date_in_the_extracted_period",
        mandatory: false,
      },
      {
        name: "vaa_ccapplicationid",
        description: "vaa_ccapplicationid",
        mandatory: false,
      },
      {
        name: "vna_ccapplicationid",
        description: "vna_ccapplicationid",
        mandatory: false,
      },
      {
        name: "vna_lwp_ccapplicationid",
        description: "vna_lwp_ccapplicationid",
        mandatory: false,
      },
      {
        name: "vna_ec_ccapplicationid",
        description: "vna_ec_ccapplicationid",
        mandatory: false,
      },
      {
        name: "vna_ab_ccapplicationid",
        description: "vna_ab_ccapplicationid",
        mandatory: false,
      },
      {
        name: "dc_ccapplicationid",
        description: "dc_ccapplicationid",
        mandatory: false,
      },
      {
        name: "o2g_ccapplicationid",
        description: "o2g_ccapplicationid",
        mandatory: false,
      },
    ],
  },
  {
    source: "ELP",
    name: "OXE Encryption",
    uploadPath: "systems/oxe/encrypt",
    acceptedTypes: ["text/csv", "application/json"],
    extensionLabel: ".csv, .json",
    delimiter: ";",
    fields: [
      {
        name: "internal_id_of_the_system",
        description: "internal_id_of_the_system",
        mandatory: true,
      },
      { name: "ui_num_ports", description: "ui_num_ports", mandatory: false },
      {
        name: "ui_num_sip_ports",
        description: "ui_num_sip_ports",
        mandatory: false,
      },
      {
        name: "ice_conferencing",
        description: "ice_conferencing",
        mandatory: false,
      },
      {
        name: "ice_univ_client",
        description: "ice_univ_client",
        mandatory: false,
      },
      {
        name: "ice_ucaas_key_ot_oxe",
        description: "ice_ucaas_key_ot_oxe",
        mandatory: false,
      },
      { name: "ice_release", description: "ice_release", mandatory: false },
      {
        name: "ot_instance_id",
        description: "ot_instance_id",
        mandatory: false,
      },
      {
        name: "ice_ucaas_key_ot_message_center",
        description: "ice_ucaas_key_ot_message_center",
        mandatory: false,
      },
      { name: "otvm_release", description: "otvm_release", mandatory: false },
      {
        name: "otmc_instance_id",
        description: "otmc_instance_id",
        mandatory: false,
      },
      { name: "8770_release", description: "8770_release", mandatory: false },
      { name: "vaa_release", description: "vaa_release", mandatory: false },
      { name: "vna_release", description: "vna_release", mandatory: false },
      {
        name: "dispatch_console_release",
        description: "dispatch_console_release",
        mandatory: false,
      },
      { name: "o2g_release", description: "o2g_release", mandatory: false },
      { name: "sbc_release", description: "sbc_release", mandatory: false },
      { name: "fax_release", description: "fax_release", mandatory: false },
      {
        name: "more_recent_date_in_the_extracted_period",
        description: "more_recent_date_in_the_extracted_period",
        mandatory: false,
      },
    ],
  },
  {
    source: "ELP",
    name: "OXO Order",
    uploadPath: "systems/oxo/orders",
    acceptedTypes: ["text/csv", "application/json"],
    extensionLabel: ".csv, .json",
    delimiter: ";",
    fields: [
      { name: "cpu_id_1", description: "cpu_id_1", mandatory: true },
      { name: "cpu_1_status", description: "cpu_1_status", mandatory: false },
      {
        name: "if_1_system_no_more_used",
        description: "if_1_system_no_more_used",
        mandatory: false,
      },
      {
        name: "internal_id_of_the_system",
        description: "internal_id_of_the_system",
        mandatory: true,
      },
      {
        name: "current_oxo_release_label",
        description: "current_oxo_release_label",
        mandatory: false,
      },
      {
        name: "current_applicant_id",
        description: "current_applicant_id",
        mandatory: true,
      },
      {
        name: "current_applicant_name",
        description: "current_applicant_name",
        mandatory: false,
      },
      {
        name: "delegated_ir_company_id",
        description: "delegated_ir_company_id",
        mandatory: true,
      },
      {
        name: "date_of_ir_delegation_creation_or_modification",
        description: "date_of_ir_delegation_creation_or_modification",
        mandatory: false,
      },
      {
        name: "date_of_the_first_sell",
        description: "date_of_the_first_sell",
        mandatory: false,
      },
      {
        name: "first_sell_ale_order",
        description: "first_sell_ale_order",
        mandatory: false,
      },
      {
        name: "first_sell_customer_order",
        description: "first_sell_customer_order",
        mandatory: false,
      },
      {
        name: "actis_id_of_the_first_sell_order",
        description: "actis_id_of_the_first_sell_order",
        mandatory: false,
      },
      {
        name: "date_of_the_last_customer_order",
        description: "date_of_the_last_customer_order",
        mandatory: true,
      },
      {
        name: "ale_order_label_of_the_last_customer_order",
        description: "ale_order_label_of_the_last_customer_order",
        mandatory: true,
      },
      {
        name: "customer_order_label_of_the_last_customer_order",
        description: "customer_order_label_of_the_last_customer_order",
        mandatory: false,
      },
      {
        name: "actis_id_of_the_last_customer_order",
        description: "actis_id_of_the_last_customer_order",
        mandatory: false,
      },
      {
        name: "date_of_the_last_operation_on_oxo_keys",
        description: "date_of_the_last_operation_on_oxo_keys",
        mandatory: false,
      },
      {
        name: "internal_cc_id_of_the_system",
        description: "internal_cc_id_of_the_system",
        mandatory: false,
      },
      {
        name: "cc_product_id_key_main",
        description: "cc_product_id_key_main",
        mandatory: false,
      },
      {
        name: "id_cc_product_key_main",
        description: "id_cc_product_key_main",
        mandatory: false,
      },
      {
        name: "account_key_main__cc_Hw_id",
        description: "account_key_main__cc_Hw_id",
        mandatory: false,
      },
      {
        name: "account_creation_date_key_main",
        description: "account_creation_date_key_main",
        mandatory: false,
      },
      {
        name: "more_recent_date_in_the_extracted_period",
        description: "more_recent_date_in_the_extracted_period",
        mandatory: false,
      },
    ],
  },
  {
    source: "ELP",
    name: "OXO Encryption",
    uploadPath: "systems/oxo/encrypt",
    acceptedTypes: ["text/csv", "application/json"],
    extensionLabel: ".csv, .json",
    delimiter: ";",
    fields: [
      {
        name: "internal_id_of_the_system",
        description: "internal_id_of_the_system",
        mandatory: true,
      },
      {
        name: "usager_advanced",
        description: "usager_advanced",
        mandatory: false,
      },
      {
        name: "nb_of_usager_advanced",
        description: "nb_of_usager_advanced",
        mandatory: false,
      },
      { name: "usager_analog", description: "usager_analog", mandatory: false },
      {
        name: "nb_of_usager_analog",
        description: "nb_of_usager_analog",
        mandatory: false,
      },
      { name: "usager_tscip", description: "usager_tscip", mandatory: false },
      {
        name: "nb_of_usager_tscip",
        description: "nb_of_usager_tscip",
        mandatory: false,
      },
      {
        name: "mobile_ip_users",
        description: "mobile_ip_users",
        mandatory: false,
      },
      {
        name: "nb_of_mobile_ip_users",
        description: "nb_of_mobile_ip_users",
        mandatory: false,
      },
      {
        name: "mobile_ip_dect_users",
        description: "mobile_ip_dect_users",
        mandatory: false,
      },
      {
        name: "nb_of_mobile_ip_dect_users",
        description: "nb_of_mobile_ip_dect_users",
        mandatory: false,
      },
      { name: "mobile_users", description: "mobile_users", mandatory: false },
      {
        name: "nb_of_mobile_users",
        description: "nb_of_mobile_users",
        mandatory: false,
      },
      { name: "acc_mobile", description: "acc_mobile", mandatory: false },
      {
        name: "nb_of_acc_mobile",
        description: "nb_of_acc_mobile",
        mandatory: false,
      },
      { name: "any_mobile", description: "any_mobile", mandatory: false },
      {
        name: "nb_of_any_mobile",
        description: "nb_of_any_mobile",
        mandatory: false,
      },
      { name: "icc_mobile", description: "icc_mobile", mandatory: false },
      {
        name: "nb_of_icc_mobile",
        description: "nb_of_icc_mobile",
        mandatory: false,
      },
      { name: "myic_office", description: "myic_office", mandatory: false },
      {
        name: "nb_of_myic_office",
        description: "nb_of_myic_office",
        mandatory: false,
      },
      { name: "pim_ip", description: "pim_ip", mandatory: false },
      { name: "nb_of_pim_ip", description: "nb_of_pim_ip", mandatory: false },
      {
        name: "my_ic_mobile_user",
        description: "my_ic_mobile_user",
        mandatory: false,
      },
      {
        name: "nb_of_my_ic_mobile_user",
        description: "nb_of_my_ic_mobile_user",
        mandatory: false,
      },
      { name: "ldap", description: "ldap", mandatory: false },
      { name: "nb_of_ldap", description: "nb_of_ldap", mandatory: false },
      { name: "iptrunk", description: "iptrunk", mandatory: false },
      { name: "nb_of_iptrunk", description: "nb_of_iptrunk", mandatory: false },
      { name: "voipchannels", description: "voipchannels", mandatory: false },
      {
        name: "nb_of_voipchannels",
        description: "nb_of_voipchannels",
        mandatory: false,
      },
      {
        name: "universal_telephony",
        description: "universal_telephony",
        mandatory: false,
      },
      {
        name: "nb_of_universal_telephony",
        description: "nb_of_universal_telephony",
        mandatory: false,
      },
      {
        name: "user_hot_desking",
        description: "user_hot_desking",
        mandatory: false,
      },
      {
        name: "nb_of_user_hot_desking",
        description: "nb_of_user_hot_desking",
        mandatory: false,
      },
      { name: "sa_period", description: "sa_period", mandatory: true },
      {
        name: "nb_of_sa_period",
        description: "nb_of_sa_period",
        mandatory: true,
      },
      { name: "sa_month", description: "sa_month", mandatory: true },
      {
        name: "nb_of_sa_month",
        description: "nb_of_sa_month",
        mandatory: true,
      },
      { name: "sa_year", description: "sa_year", mandatory: true },
      { name: "nb_of_sa_year", description: "nb_of_sa_year", mandatory: true },
      {
        name: "more_recent_date_in_the_extracted_period",
        description: "more_recent_date_in_the_extracted_period",
        mandatory: false,
      },
    ],
  },
];
